import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AccountsApi } from '../../apis';
import { NewAccount } from '../../models/accounts';
import { QueryKeys } from '../query-keys';

const useCreateAccount = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (account: NewAccount) => AccountsApi.create(account),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ACCOUNTS] });
    },
  });

  return {
    createAccount: mutation.mutateAsync,
    isCreating: mutation.isPending,
    wasCreatedWithSuccess: mutation.isSuccess,
    wasCreatedWithoutSuccess: mutation.isError,
  };
};

export default useCreateAccount;
